export function getTGDataFromWebApp() {
    return window.Telegram.WebApp.initDataUnsafe;
}

export function getTGSafeDataFromWebApp() {
    return window.Telegram.WebApp.initData;
}
